const PALETTE = [
  '#e11d48',
  '#7c3aed',
  '#2563eb',
  '#059669',
  '#d97706',
  '#0891b2',
  '#db2777',
  '#4f46e5',
] as const;

/** Stable accent colour for a project id or name. */
export function projectColor(seed: string): string {
  if (seed.length === 0) {
    throw new Error('projectColor requires a non-empty seed.');
  }
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % PALETTE.length;
  const color = PALETTE[index];
  if (!color) {
    throw new Error('Project colour palette is empty.');
  }
  return color;
}
